import { OfficeWorkload, } from '@office-start/officehome-types';
/**
 * First Run should only be shown on the root path of the app
 */
export function checkIsSupportedPath(officeComponentContext) {
    var isDesktop = officeComponentContext.workload === OfficeWorkload.Hwa;
    var isSupportedPath = true;
    if (isDesktop) {
        if (location.pathname !== '/pwa') {
            isSupportedPath = false;
        }
    }
    else {
        if (location.pathname !== '/') {
            isSupportedPath = false;
        }
    }
    return isSupportedPath;
}
//# sourceMappingURL=checkIsSupportedPath.js.map